import React from "react";
import { Empty, Button, Tooltip } from "antd";
import { PlusCircleOutlined } from "@ant-design/icons";
import styles from "./HistoryList.module.css";

interface IHistoryListProps {
  onAddNew?: () => void;
  onViewItem?: (item: any, orderNumber: number) => void;
  loading?: boolean;
  isLastUnlistedProcedureCompleted: boolean;
  getAllUnlistedProcedures: any;
}

const HistoryList: React.FC<IHistoryListProps> = ({
  onAddNew,
  onViewItem,
  loading = false,
  isLastUnlistedProcedureCompleted,
  getAllUnlistedProcedures,
}) => {
  const orderedUnlistedProcedures = [...(getAllUnlistedProcedures || [])]; //.reverse()

  const getProcedureNames = (item: any) =>
    item?.procedures?.map((proc: any) => proc?.procedureName).join(", ") ||
    "No procedures";

  const getTotalCost = (item: any) =>
    item?.procedures?.reduce(
      (total: number, proc: any) => total + (proc?.cost || 0),
      0,
    );

  return (
    <div
      className={styles.historyListContainer}
      style={{
        height: getAllUnlistedProcedures?.[0]?.annextureSubmittedOnPortal
          ? "120vh"
          : "60vh",
      }}
    >
      <div className={styles.header}>
        <div>
          <h3 className={styles.title}>PROCEDURE HISTORY</h3>
        </div>
        {onAddNew && isLastUnlistedProcedureCompleted && (
          <Button
            type="primary"
            icon={<PlusCircleOutlined />}
            onClick={onAddNew}
            loading={loading}
            style={{ background: "#00549E", color: "white" }}
          >
            Add New
          </Button>
        )}
      </div>

      {orderedUnlistedProcedures.length > 0 ? (
        <div className={styles.listContainer}>
          {orderedUnlistedProcedures.map((item: any, index: number) => {
            const orderNumber = orderedUnlistedProcedures.length - index;
            const procedureText = getProcedureNames(item);
            const totalCost = getTotalCost(item);
            return (
              <div
                key={`${item.caseId}-${orderNumber}`}
                className={styles.historyCard}
              >
                <div className={styles.cardHeader}>
                  <div>
                    <h4 className={styles.cardTitle}>
                      Unlisted Procedure - {orderNumber}
                    </h4>
                    <p className={styles.cardMeta}>
                      {item?.procedures?.length ?? 0} procedure(s) • Total Cost:
                      ₹{totalCost}
                    </p>
                  </div>

                  {onViewItem ? (
                    <Button
                      type="primary"
                      onClick={() => onViewItem(item, orderNumber)}
                    >
                      View Details
                    </Button>
                  ) : null}
                </div>

                <div className={styles.cardBody}>
                  <div className={styles.cardRow}>
                    <span className={styles.cardLabel}>Remarks:</span>
                    <span className={styles.cardValue}>
                      {item?.remarks || "-"}
                    </span>
                  </div>

                  <div className={styles.cardRow}>
                    <span className={styles.cardLabel}>Procedures:</span>
                    <Tooltip title={procedureText} placement="topLeft">
                      <span className={styles.cardValue}>{procedureText}</span>
                    </Tooltip>
                  </div>

                  {/* <div className={styles.cardRow}>
                    <span className={styles.cardMetaBlock}>
                      <strong>Annexure Uploaded:</strong>{' '}
                      {item?.annextureUploaded ? 'Yes' : 'No'}
                    </span>
                    <span className={styles.cardMetaBlock}>
                      <strong>Submitted on Portal:</strong>{' '}
                      {item?.annextureSubmittedOnPortal ? 'Yes' : 'No'}
                    </span>
                  </div> */}
                  <div className={styles.cardRow}>
                    <span className={styles.cardMetaBlock}>
                      <strong>Annexure Uploaded:</strong>
                      <span
                        className={
                          item?.annextureUploaded
                            ? styles.statusYes
                            : styles.statusNo
                        }
                      >
                        {item?.annextureUploaded ? "Yes" : "No"}
                      </span>
                    </span>

                    <span className={styles.cardMetaBlock}>
                      <strong>Submitted on Portal:</strong>
                      <span
                        className={
                          item?.annextureSubmittedOnPortal
                            ? styles.statusYes
                            : styles.statusNo
                        }
                      >
                        {item?.annextureSubmittedOnPortal ? "Yes" : "No"}
                      </span>
                    </span>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      ) : (
        <Empty description="No procedures found" />
      )}
    </div>
  );
};

export default HistoryList;
